<template>
  <div class="hello">
    <div style="width: 100%; position: relative">
      <el-image
        style="position: absolute; width: 100%; height: auto"
        :src="require('@/assets/pc/pc_bg.png')"
        fit="cover"
      />

      <div class="topView">
        <div class="navView">
          <el-image
            style="width: 151px; margin-right: 290px"
            :src="require('@/assets/pc/pc_logo.png')"
            fit="contain"
          />
          <el-button type="text" class="navText">服务支持</el-button>
          <el-button type="text" class="navText">社区</el-button>
          <el-button type="text" class="navText" @click="onGotoDownload"
            >下载APP</el-button
          >
          <el-button type="text" class="navText">官方微信</el-button>
          <el-button type="text" class="navText">官方微博</el-button>
        </div>

        <div class="logo-tip">
          <span style="font-size: 40px; color: #fff1f1"
            >个人专属的数据分析+精准智能的专业点评</span
          >
          <span style="font-size: 40px; color: #fff1f1"
            >您最需要的健康知识</span
          >
          <span
            style="
              font-size: 16px;
              color: #fff1f1;
              text-align: center;
              margin-top: 12px;
            "
          >
            按日、周、月统计分析数据趋势，及时警示；结合三高数据、症状、用药、检查报告，综合
          </span>
          <span style="font-size: 16px; color: #fff1f1; text-align: center">
            分析健康风险；智能算法+真人医生共同看护您的健康状态，以此推送您最需要的健康知识
          </span>
        </div>

        <div class="bannerView">
          <el-image
            style="width: 50px; height: 482px"
            src="https://img.veim.cn/images-pc/pc_banner0.png"
            fit="cover"
          />

          <div
            style="position: relative; width: 230px; height: 482px"
            v-for="(item, i) in banners"
            :key="item.src"
          >
            <el-image
              style="position: absolute; width: 230px; height: 482px"
              :src="item.src"
              fit="cover"
            />

            <el-image class="anima"
              v-if="selectIndex == i"
              style="
                position: absolute;
                width: 281px;
                height: 482px;
                left: -50px;
              "
              src="https://img.veim.cn/images-pc/pc_banner_cover.png"
            />
            <el-button
              class="button"
              style="position: absolute; bottom: 30px; left: 20px;z-index: 10001"
              @click="onClickButton(i)"
              >{{ titles[i] }}</el-button
            >

            <el-image class="anima"
              v-if="selectIndex == i"
              style="position: absolute; left: -160px; width: 340px; top: -32px"
              :src="item.popup"
              fit="contain"
            />
          </div>
        </div>

        <span class="title" style="margin-top: 40px"
          >一键记录指标，永久免费保存</span
        >
        <span class="desc" style="margin-top: 10px"
          >记录特别方便，小程序上能导出成图保存</span
        >

        <div class="categoryView">
          <div class="item" style="margin-top: 50px">
            <div class="table-cell-view">
              <div class="cell">
                <el-image
                  style="width: 40px"
                  :src="require('@/assets/home/table_cell1.png')"
                  fit="contain"
                />
                <span class="desc" style="padding-top: 10px; text-align: center"
                  >趋势图，方便看趋势</span
                >
              </div>

              <div class="cell">
                <el-image
                  style="width: 40px"
                  :src="require('@/assets/home/table_cell2.png')"
                  fit="contain"
                />
                <span
                  class="desc"
                  style="
                    padding-top: 10px;
                    text-align: center;
                    width: 120px;
                    line-height: 30px;
                  "
                  >表格，按日分开利于保存转发</span
                >
              </div>
            </div>

            <div
              style="
                background: #dedede;
                margin: 0 0px 30px 0px;
                width: 78%;
                height: 1px;
              "
            ></div>

            <div class="table-view">
              <div
                class="item"
                v-for="(item, i) in items"
                :key="item.text"
                @click="onClickCategory(i)"
              >
                <el-image
                  class="image"
                  style="height: auto"
                  :src="item.image"
                  fit="contain"
                />
                <span class="desc" style="font-size: 18px">{{
                  item.text
                }}</span>
              </div>
            </div>

            <div
              style="
                background: #dedede;
                margin: 0 0px 30px 0px;
                width: 78%;
                height: 1px;
              "
            ></div>
            <span
              class="desc"
              style="
                padding-top: 10px;
                text-align: center;
                font-weight: bold;
                color: #4a4a4a;
              "
              >APP将很快提供保存到本机功能：</span
            >
            <span class="desc" style="padding-top: 10px; text-align: center">
              可补记以前的血压、心率、血脂、尿酸等</span
            >
          </div>
          <div class="item">
            <div class="mobile-view" v-if="categoryIndex == 1">
              <el-image
                class="image"
                style="width: 310px; height: auto"
                :src="items[categoryIndex].src"
              />
            </div>
            <div class="mobile-view" v-else>
              <video
                class="image"
                style="width: 248px; height: auto"
                :src="items[categoryIndex].url"
                autoplay
                loop
                muted
              />

              <el-image
                style="
                  position: absolute;
                  top: 0px;
                  left: 30px;
                  right: 30px;
                  bottom: 0px;
                "
                :src="require('@/assets/home/mobile.png')"
                fit="contain"
              />
            </div>
          </div>
        </div>

        <div class="topView" style="position: relative; margin-top: -410px">
          <el-image
            style="
              position: absolute;
              top: 0px;
              bottom: 0;
              left: 0;
              right: 0;
              z-index: -1;
            "
            src="https://img.veim.cn/images-pc/pc_bg2.png"
            fit="container"
          />

          <span class="title" style="margin-top: 440px"
            >健康话题的聚集地，三高人群的网上咖啡厅</span
          >
          <span class="desc" style="margin-top: 10px; margin-bottom: 40px"
            >快捷发布，能一键发布血压记录、常见问题</span
          >

          <div class="lubo-view">
            <div class="item" v-for="item in lunboItems" :key="item.text">
              <!-- <el-image
                class="image"
                style="width: 390px; height: auto"
                :src="item.src"
                fit="contain"
              /> -->
              <div
                style="
                  position: relative;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-items: center;
                "
                class="image"
              >
                <video
                  class="image"
                  style="width: 290px; height: auto"
                  :src="item.url"
                  autoplay
                  loop
                  muted
                />

                <el-image
                  style="
                    position: absolute;
                    top: -16px;
                    left: 0;
                    right: 0;
                    bottom: -16px;
                  "
                  :src="require('@/assets/home/mobile.png')"
                  fit="contain"
                />
              </div>

              <span class="title" style="padding-top: 40px">{{
                item.title
              }}</span>
              <span
                class="desc"
                style="margin: 10px 60px 10px 60px; text-align: center"
                >{{ item.desc }}</span
              >
            </div>
          </div>
        </div>

        <div class="bottom-view2" id="download">
          <el-image
            class="bg"
            src="https://img.veim.cn/images-pc/pc_bg3.png"
            fit="cover"
          />

          <el-image
            class="logo"
            :src="require('@/assets/big_logo.png')"
            fit="contain"
          />
          <span style="font-weight: bold;font-size: 42px;margin-top: 10px;">健康云血压记</span>
          <span
            style="
              width: 558px;
              height: 44px;
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #9b9b9b;
              line-height: 22px;
              letter-spacing: 1px;
              text-align: center;
              padding-top: 20px;
              margin-bottom: 250px;
            "
            >集指标记录保存、数据分析统计、互动社区于一身，助您控制自己的血压，一个有温度的APP，与您健康长伴。</span
          >

          <div class="download-view">
            <div class="father">
              <el-button style="font-weight: 600">Android版</el-button>
              <el-image
                style="width: 110px; height: 110px"
                :src="require('@/assets/home/qrcode.png')"
                fit="contain"
              />
            </div>

            <div class="father">
              <el-button style="font-weight: 600">小程序版</el-button>
              <el-image
                style="width: 110px; height: 110px"
                :src="require('@/assets/home/qrcode.jpeg')"
                fit="contain"
              />
            </div>
          </div>

          <!-- <router-link :to="{ name: 'Download' }" style="z-index: 100">
            <el-button type="primary" class="download-button"
              >点我下载</el-button
            >
          </router-link> -->

          <!-- <el-image
            class="qrcode"
            :src="require('@/assets/home/qrcode.jpeg')"
            fit="contain"
          /> -->
        </div>

        <div
          style="
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-items: center;
            background: #006bd2;
            padding: 10px;
          "
        >
          <div
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-items: center;
            "
          >
            <el-button type="text" class="navText">官方微信</el-button>
            <el-button type="text" class="navText">官方微博</el-button>
            <el-button type="text" class="navText">客服邮箱</el-button>
            <el-button type="text" class="navText">加入我们</el-button>
          </div>

          <span
            style="
              width: 509px;
              height: 20px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #ffffff;
              line-height: 20px;
              padding-top: 40px;
              padding-bottom: 10px;
            "
            >Copyright 2022 weimeng.com,All Rights Reserved.
            上海威萌网络科技有限公司</span
          >
          <div
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-items: center;
              padding-bottom: 10px;
            "
          >
            

            <el-image
              style="width: 19px; margin: 0 4px"
              :src="require('@/assets/pc/pc_gongan.png')"
            />
            <a
              style="
                height: 20px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                line-height: 20px;
                text-decoration: none;
              "
              href="https://beian.miit.gov.cn/"
              target="_blank"
              >沪ICP备15044998号</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      selectIndex: 0,
      banners: [
        {
          src: require('@/assets/pc/pc_banner1.png'),
          popup: "https://img.veim.cn/images-pc/pc_popup4.png",
        },
        {
          src: "https://img.veim.cn/images-pc/pc_banner2.png",
          popup: "https://img.veim.cn/images-pc/pc_popup2.png",
        },
        {
          src: "https://img.veim.cn/images-pc/pc_banner3.png",
          popup: "https://img.veim.cn/images-pc/pc_popup3.png",
        },
        {
          src: "https://img.veim.cn/images-pc/pc_banner4.png",
          popup: "https://img.veim.cn/images-pc/pc_popup1.png",
        },
      ],
      titles: ["血压分析", "用药分析", "尿酸分析", "血脂分析"],
      categoryIndex: 0,
      items: [
        {
          image: require("@/assets/home/icon1.png"),
          text: "血压",
          src: "https://img.veim.cn/images/category1.png",
          url: "https://dl.veim.cn/download/video/血压1.mp4",
        },
        {
          image: require("@/assets/home/icon2.png"),
          text: "血糖",
          src: "https://img.veim.cn/images/category2.png",
          url: "https://dl.veim.cn/download/video/尿酸1.mp4",
        },
        {
          image: require("@/assets/home/icon3.png"),
          text: "记录用药",
          src: "https://img.veim.cn/images/category3.png",
          url: "https://dl.veim.cn/download/video/用药1.mp4",
        },
        {
          image: require("@/assets/home/icon4.png"),
          text: "尿酸",
          src: "https://img.veim.cn/images/category4.png",
          url: "https://dl.veim.cn/download/video/尿酸1.mp4",
        },
        {
          image: require("@/assets/home/icon5.png"),
          text: "血脂",
          src: "https://img.veim.cn/images/category5.png",
          url: "https://dl.veim.cn/download/video/血脂1.mp4",
        },
        {
          image: require("@/assets/home/icon6.png"),
          text: "症状",
          src: "https://img.veim.cn/images/category6.png",
          url: "https://dl.veim.cn/download/video/症状1.mp4",
        },
      ],
      lunboItems: [
        {
          src: "https://img.veim.cn/images/lunbo1.png",
          url: "https://dl.veim.cn/download/video/问医生1.mp4",
          title: "科普答疑不用取号",
          desc: "健康问题能够得到热心的回答和指导。",
        },
        {
          src: "https://img.veim.cn/images/lunbo2.png",
          url: "https://dl.veim.cn/download/video/问网友1.mp4",
          title: "同病交友聊天",
          desc:
            "和病友之间，分享您的经验、得到共鸣；宣泄您的情感，得到安慰；同病相怜的聊天，才最能获得安慰；",
        },
        {
          src: "https://img.veim.cn/images/lunbo3.png",
          url:
            "https://dl.veim.cn/download/video/%E5%8F%91%E5%B8%96%E6%96%B9%E4%BE%BF1.mp4",
          title: "快捷发帖；即时分享",
          desc:
            "血压数据和常用问题都已给您准备好，一键发布；丰富的图文发布功能，方便编辑和转发，让更多人知道你",
        },
        {
          src: "https://img.veim.cn/images/lunbo4.png",
          url:
            "https://dl.veim.cn/download/video/%E5%8F%91%E8%B5%B7%E6%8A%95%E7%A5%A81.mp4",
          title: "投票功能",
          desc:
            "拿不准的想法，除了问医生，还想看看病友怎么做的，那你发起一个投票好了；",
        },
      ],
      total: 0,
      distance: 0,
      step: 0,
    };
  },

  created() {
    this.dataRefreh();
    this.lunboItems = this.lunboItems;
  },
  mounted() {
    if (this._isMobile()) {
      // alert("手机端");
      this.$router.replace("/");
    } else {
      // alert("pc端");
      // this.$router.replace('/pc');
    }
  },
  destroyed() {
    // 在页面销毁后，清除计时器
    this.clear();
  },

  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    // 定时刷新数据函数
    dataRefreh() {
      // 计时器正在进行中，退出函数
      if (this.intervalId != null) {
        return;
      }
      // 计时器为空，操作
      this.intervalId = setInterval(() => {
        this.selectIndex += 1;
        if (this.selectIndex > 3) {
          this.selectIndex = 0;
        }
      }, 3000);

    },
    // 停止定时器
    clear() {
      clearInterval(this.intervalId); //清除计时器
      this.intervalId = null; //设置为null
    },
    //this.$router.push({ path: '/news', query: { userId: 123 }});
    onchange: function (e1, e2) {
      this.selectIndex = e1;
    },
    onClickButton: function (index) {
      this.selectIndex = index;
      this.clear();
      this.dataRefreh();
    },
    onClickCategory: function (index) {
      this.categoryIndex = index;
      console.log(this.items[index].url);
      console.log(this.categoryIndex);
    },

    onGotoDownload: function () {
      // let jump = document.querySelector("#download"); //定义起跳点div
      document.querySelector("#download").scrollIntoView(true);
      // this.total = jump.offsetTop;
      // this.distance =
      //   document.documentElement.scrollTop || document.body.scrollTop;
      // // 平滑滚动，时长500ms，每10ms一跳，共50跳
      // this.step = this.total / 80;
      // if (this.total > this.distance) {
      //   this.smoothDown();
      // } else {
      //   let newTotal = this.distance -  this.total;
      //   this.step = newTotal / 80;
      //   this.smoothUp();
      // }
    },

    smoothDown: function () {
      var distance = this.distance;
      var total = this.total;
      if (distance < total) {
        distance += this.step;
        document.body.scrollTop = distance;
        document.documentElement.scrollTop = distance;
        setTimeout(this.smoothDown(), 10);
      } else {
        document.body.scrollTop = total;
        document.documentElement.scrollTop = total;
      }
    },
    smoothUp: function () {
      if (distance > total) {
        distance -= step;
        document.body.scrollTop = distance;
        document.documentElement.scrollTop = distance;
        setTimeout(smoothUp, 10);
      } else {
        document.body.scrollTop = total;
        document.documentElement.scrollTop = total;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.anima {
  animation-name: example;
  animation-duration: 2s;
  /* animation-delay: 2s; */
  z-index: 1000;
  opacity: 1;
}
@keyframes example {
  0% { opacity: 0 }
	100% { opacity: 1 }
}
body {
  margin: 0px;
}
.hello {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: -8px;
  /* background-color: #38a8fa; */
}
.logo-tip {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  margin-top: 50px;
}
.topView {
  position: absolute;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
}
.topView .navView {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-items: center;
  margin: 20px;
}
.navText {
  color: #fff;
  margin: 0 50px;
}
.bannerView {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-items: center;
  margin-top: 50px;
}

.title {
  font-size: 30px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #333333;
  line-height: 42px;
}
.desc {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #9b9b9b;
  line-height: 22px;
}

.categoryView {
  display: flex;
  flex-direction: row;
  /* align-items: center; */
  /* justify-items: center; */
  margin-top: 40px;
  z-index: 1000;
}

.categoryView .item {
  width: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
}
.image {
  width: 100%;
}
.button-view {
}
.layout {
  display: flex;
  justify-content: center;
  align-items: center;
}
.button {
  background: transparent;
  color: #ffffff;
}
.button-view .button-active {
  background: rgba(255, 255, 255, 0.33);
  color: #ffffff;
}
.triangle-bottomright {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-bottom: 80px solid #ffffff;
  border-left: 100vw solid transparent;
}
.triangle-bottomright-blue {
  /* position: absolute;
  bottom: -20px;
  left: 0;
  right: 0; */
  margin-top: -150px;
  border-bottom: 150px solid #f2f9ff;
  border-left: 100vw solid transparent;
}
.table-cell-view {
  display: flex;
  margin: 20px 0;
  /* margin-left: 20px; */
  width: 100%;
  box-sizing: border-box;
  padding: 0px 40px;
}
.table-cell-view .cell {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* margin: 0px 20px; */
  box-sizing: border-box;
}
.download-button {
  width: 293px;
  height: 50px;
  background: linear-gradient(180deg, #0f89ff 0%, #006bd2 100%);
  border-radius: 28px;
  font-size: 22px;
}
.table-view {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 20px 20px;
}
.table-view .item {
  width: 33.33%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  /* margin: 30px; */
  padding: 0px 26px 26px 26px;
  box-sizing: border-box;
}
.table-view .item .desc {
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 28px;
  padding-top: 10px;
}
.mobile-view {
  position: relative;
  width: 348px;
  height: 752px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 100px;
  margin-top: -20px;
  /* background: yellow; */
}
.mobile-view .image {
  position: absolute;
  width: 348px;
  /* height: 476px; */
}
.mobile-view .video {
  position: absolute;
  width: 204px;
  height: 450px;
  margin-top: 2px;
}

.lubo-view {
  width: 60%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding-bottom: 60px;
}

.lubo-view .item {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  /* margin: 30px; */
  padding: 50px 0px 0px 0px;
  box-sizing: border-box;
}

.blue-title-view {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f2f9ff;
  padding: 20px 0;
}
.bottom-view {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #006bd2;
}
.bottom-view .text {
  color: #ffffff;
  font-size: 14px;
  text-align: center;
  padding-top: 70px;
  padding-bottom: 90px;
}
.download-view {
  position: fixed;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  padding: 10px 0;
  z-index: 100;
}
.bottom-view2 {
  position: relative;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  width: 100%;
  /* height: 375px; */
  /* background: yellow; */
}
.bottom-view2 .bg {
  position: absolute;
  top: 0px;
  bottom: 0;
  left: 0;
  right: 0;
}
.bottom-view2 .logo {
  width: 176px;
  height: auto;
  margin-top: 50px;
  border-radius: 12px;
}
.qrcode {
  position: absolute;
  bottom: -55px;
  width: 140px;
  height: 140px;
}
.download-view {
  position: absolute;
  bottom: 50px;
  display: flex;
  flex-direction: row;
  background: transparent;
}
.father {
  /* position: absolute; */
  /* display: flex; */
  /* flex-direction: column; */
  margin-left: 30px;
  display: flex;
  flex-direction: column;
}
.element {
  display: none;
  position: absolute;
}

.father:hover .element {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/HomePC.vue